var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTypeMedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.5 16l-4.9-6.1-13 16 4.9 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.4 0l-13 16 5 6 13-15.9z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeMedIcon);
export default __webpack_public_path__ + "static/media/type-med-icon.4a165092fc2b3fdd51bfab9780065c5f.svg";
export { ForwardRef as ReactComponent };